export default __webpack_public_path__ + "img/cloud.f74d6791.svg";